import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams, Link, useNavigate } from "react-router-dom";
import { FaLocationDot } from "react-icons/fa6";
import "./DoctorList.css";


const DoctorList = () => {
  const [doctors, setDoctors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [expandedDoctorId, setExpandedDoctorId] = useState(null); // Track expanded doctor
  const { category } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
}, []);


  useEffect(() => {
    const fetchDoctors = async () => {
      try {
        const response = await axios.get(
          `https://api.swasthmitra.com/api/doctor/category/${category}`
        );
        setDoctors(response.data.data);
        setLoading(false);
      } catch (err) {
        setError("Failed to fetch doctors. Please try again later.");
        setLoading(false);
      }
    };

    fetchDoctors();
  }, [category]);

  const handleAppointmentClick = (doctor, hospital) => {
    navigate("/appointment", {
      state: {
        doctorName: doctor.name,
        hospitalName: hospital.name,
        hospitalAddress: hospital.address,
      },
    });
  };

  const toggleAboutSection = (doctorId) => {
    if (expandedDoctorId === doctorId) {
      setExpandedDoctorId(null); // Collapse if already expanded
    } else {
      setExpandedDoctorId(doctorId); // Expand the new doctor
    }
  };

  if (loading) return <div className="loading">Loading doctors...</div>;

  if (error) return <div className="error">{error}</div>;

  return (
    <div className="doctor-list-container">
      <h3 className="category-heading">Doctors in <span>{category}</span>Category</h3>
      <div className="doctor-cards">
        {doctors.map((doctor) => (
          <div key={doctor._id} className="doctor-card">
            <div className="doctor-container">
              <img
                src={doctor.imageUrl || "https://via.placeholder.com/150"}
                alt={doctor.name}
                className="doctor-image"
              />
              <div className="doctor-details">
                <h2 className="doctor-name">{doctor.name}</h2>
                <p className="doctor-specialization">{doctor.specialization}</p>
                <p className="doctor-contact">Contact: {doctor.mobileNum}</p>
              </div>
            </div>
            <div className="doctor-about-container">
              <p
                className={`doctor-about ${
                  expandedDoctorId === doctor._id ? "expanded" : ""
                }`}
                dangerouslySetInnerHTML={{ __html: doctor.about }}
              ></p>
              <span
                className="show-more"
                onClick={() => toggleAboutSection(doctor._id)}
              >
                {expandedDoctorId === doctor._id ? "Show Less" : "Show More"}
              </span>
            </div>
            {doctor.hospitals && doctor.hospitals.length > 0 && (
              <div className="doctor-hospitals">
                <h4>Hospitals:</h4>
                {doctor.hospitals.map((hospital) => (
                  <div key={hospital._id} className="hospital-details">
                    <p>
                      <strong style={{ fontWeight: "bold" }}>
                        Hospital Name:{" "}
                      </strong>
                      {hospital.name}
                    </p>
                    <p>
                      <strong>
                        <FaLocationDot />
                      </strong>{" "}
                      {hospital.address.length > 60
                        ? `${hospital.address.slice(0, 65)}...`
                        : hospital.address}
                    </p>

                    <div className="book">
                      <span
                        onClick={() => handleAppointmentClick(doctor, hospital)}
                      >
                        Appointment
                      </span>
                      <Link
                        to={`/hospital/${hospital._id}`}
                        className="hospital-link"
                      >
                        <span>Visit Hospital</span>
                      </Link>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default DoctorList;
